export enum FounderLevel {
  STACK_CERTIFIED = "Stack Certified",
  STACK_PRO = "Stack Pro",
  STACK_X = "Stack X",
}

export interface Milestone {
  id: string;
  title: string;
  completed: boolean;
  progress?: number;
  total?: number;
  isAutomatic: boolean;
}

export interface LevelProgress {
  currentLevel: FounderLevel | null;
  nextLevel: FounderLevel | null;
  milestones: Milestone[];
  levelUnlocked: boolean;
}
